<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1">Permissões</h1>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-8 col-12">
          <label>PERFIL</label>
          <select
            v-model="profile_id"
            @change="getPermissions"
            class="form-control"
          >
            <option
              v-for="(profile, index) in profiles"
              :key="index"
              :value="profile.id"
              v-show="profile.name != master"
            >
              {{ profile.name }}
            </option>
          </select>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-8 col-12">
          <label>PESQUISAR PERMISSÕES</label>
          <input :loading="loading" v-model="search" class="form-control" />
        </div>
        <div class="col-md-12 text-right">
          <button
            @click="botaoInvisivelValor()"
            style="opacity: 0; cursor: default"
          >
            CLICAR AQUI
          </button>
          <input
            type="text"
            @keyup="pegarpegarValorInputInvisivel()"
            :class="inputInvisivel"
            v-model="inputInvisivelValor"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <ErrorsMessages :errors="errors" />
          <v-data-table
            dense
            disable-pagination
            fixed-header
            height="600"
            hide-default-footer
            :headers="headers"
            :items="permissions_items"
            :search="search"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :loading="loading"
            group-by="group_name"
          >
            <template
              v-slot:[`group.header`]="{ group, headers, toggle, isOpen }"
            >
              <td :colspan="headers.length" @click="toggle" class="pt-1 pb-1">
                <div class="d-flex">
                  <v-btn x-small icon :ref="group">
                    <i class="fas fa-caret-down fa-2x" v-if="isOpen"></i>
                    <i class="fas fa-caret-up fa-2x" v-else></i>
                  </v-btn>
                  <h6 class="ml-2 mb-0 color-blue">
                    {{ group.toUpperCase() }}
                  </h6>
                </div>
              </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="row">
                <div
                  class="col-md-4 pt-0 pb-0"
                  v-for="action in item.actions"
                  :key="action.id"
                >
                  <h6 class="m-0 text-eleven upper-text">
                    {{
                      String(action.name).toUpperCase() == "VISUALIZAR"
                        ? "VER"
                        : action.name
                    }}
                  </h6>
                  <v-switch
                    :disabled="!permission('edit', 'permission')"
                    :color="
                      permission('edit', 'permission') ? 'secondary' : 'light'
                    "
                    class="mx-0 my-0"
                    dense
                    hide-details
                    inset
                    v-model="action.allowed"
                    @change="toggleAction(item, action)"
                  />
                </div>
              </div>
            </template>
            <template v-slot:[`item.logs`]="{ item }">
              <v-btn small class="btn-annotation m-1" @click="showLogs(item)">
                <i class="fas fa-eye mr-1"></i> LOGS
              </v-btn>
              <b-modal
                size="lg"
                no-close-on-backdrop
                :id="`permission_log_${item.id}`"
                :title="item.name"
                hide-footer
              >
                <Logs :users="users" :item="item" />
              </b-modal>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Logs from "../templates/Permission/logs";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import routes from "../routes";

export default {
  name: "PermissionsAlt",

  components: {
    AuthBySessionExpired,
    NavBar,
    ErrorsMessages,
    Logs,
  },

  data() {
    return {
      botaoInvisivel: false,
      inputInvisivel: "d-none",
      inputInvisivelValor: "",
      cahveInputInvisivel: "123",
      master: "MASTER",
      users: [],

      errors: [],
      loading: false,

      //profiles
      profiles: [],
      profile_id: "",

      //permissions
      search: "",
      headers: [
        { text: "Grupo", value: "group_name" },
        { text: "Nome", value: "name" },
        { text: "Descrição", value: "description", filterable: false },
        { text: "Ações", value: "actions", filterable: false },
        { text: "Logs", value: "logs", filterable: false },
      ],
      permissions_items: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    botaoInvisivelValor() {
      this.botaoInvisivel
        ? (this.botaoInvisivel = false)
        : (this.botaoInvisivel = true);

      if (this.botaoInvisivel) {
        this.inputInvisivel = "bg-white";
      } else {
        this.inputInvisivel = "d-none bg-white";
        this.inputInvisivelValor = "";
      }
    },

    pegarpegarValorInputInvisivel() {
      if (this.inputInvisivelValor == this.cahveInputInvisivel) {
        this.master = "";
        this.inputInvisivel = "d-none bg-white";
      } else {
        this.master = "MASTER";
      }
    },

    showLogs(item) {
      this.$bvModal.show(`permission_log_${item.id}`);
    },

    async retrieve() {
      await this.getProfiles();
      if (this.profiles.length > 0) this.profile_id = this.profiles[0].id;
      await this.getPermissions();
      await this.getUsers();
    },

    async getProfiles() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/profiles");
        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.profiles = profiles;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getPermissions() {
      try {
        this.loading = true;

        const params = {
          profile_id: this.profile_id,
        };
        let response = await api.get("/rest-home/permissions/by-profile", {
          params,
        });
        const { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.permissions_items = permissions;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUsers() {
      try {
        let response = await api.get("/rest-home/users");

        let { error, users } = response.data;

        if (!error) {
          this.users = users;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async toggleAction(item, action) {
      this.loading = true;

      try {
        const data = {
          profile_id: this.profile_id,
          permission_id: item.id,
          action_id: action.id,
        };
        const response = await api.patch("/rest-home/permission/toggle", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          await this.getPermissions();
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>
